<template>
  <section v-if="badges.length" id="badges" class="badge-section">
    <v-container>
      <p>Earned Along the Way</p>
      <h2>Merit Badges</h2>
      <div class="badge-grid">
        <router-link
          v-for="badge in badges"
          :key="badge.slug || badge.id || badge.title"
          :to="badgeRoute(badge)"
          class="badge-card"
          :aria-label="`View the adventure for ${badge.title || badge.name}`"
        >
          <div class="badge-artwork">
            <v-img
              v-if="badge.image"
              :src="badge.image | mediaSrc"
              :alt="badge.title || badge.name"
              aspect-ratio="1"
              class="badge-image"
            ></v-img>
            <v-icon v-else class="badge-placeholder">mdi-medal-outline</v-icon>
          </div>
          <div class="badge-title">
            <strong>{{ badge.title || badge.name }}</strong>
            <v-icon small aria-hidden="true">mdi-arrow-right</v-icon>
          </div>
        </router-link>
      </div>
    </v-container>
  </section>
</template>

<script>
export default {
  name: 'MeritBadgeSection',
  props: { badges: { type: Array, default: () => [] } },
  methods: {
    badgeRoute(badge) {
      return { name: 'reckon-way-gallery', params: { gallerySlug: badge.tripSlug } };
    },
  },
};
</script>

<style scoped>
.badge-section { background: #0b0b0b; border-top: 1px solid #242424; padding: 72px 0; scroll-margin-top: 68px; }
.badge-section > .container > p { color: #e23232; font-family: "Oswald", sans-serif; font-weight: 800; text-transform: uppercase; }
h2 { color: #fff; font-family: "Oswald", sans-serif; font-size: 2.8rem; margin: 0 0 28px; }
.badge-grid { display: grid; gap: 20px; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); }
.badge-card { background: #101010; border: 1px solid #2d2d2d; border-radius: 14px; color: #fff !important; display: block; overflow: hidden; text-decoration: none; transition: border-color 180ms ease, box-shadow 180ms ease, transform 180ms ease; }
.badge-card:hover { border-color: #e23232; box-shadow: 0 16px 36px rgba(0, 0, 0, .35); transform: translateY(-4px); }
.badge-card:focus-visible { outline: 3px solid #fff; outline-offset: 4px; }
.badge-artwork { align-items: center; aspect-ratio: 1; background: radial-gradient(circle, #202020 0, #090909 72%); display: flex; justify-content: center; overflow: hidden; width: 100%; }
.badge-image { clip-path: circle(48.5% at 50% 50%); height: 100%; transform: scale(1.04); width: 100%; }
.badge-placeholder { color: #f0b13c !important; font-size: clamp(5rem, 12vw, 8rem) !important; }
.badge-title { align-items: center; border-top: 1px solid #282828; display: flex; gap: 12px; justify-content: space-between; min-height: 72px; padding: 16px 18px; }
.badge-title strong { color: #fff; font-size: 1rem; line-height: 1.3; }
.badge-title .v-icon { color: #e23232; flex: 0 0 auto; }
@media (max-width: 520px) { .badge-grid { grid-template-columns: 1fr; } }
@media (prefers-reduced-motion: reduce) { .badge-card { transition: none; } }
</style>
